import * as React from "react";
import { connect } from "react-redux";
import Spinner from '../common/spinner';
import GenericInput from "../common/input/GenericInput";
import ZipCode from "../common/input/ZipInput";
import DatePicker from "../common/DatePicker";
import DataComponent from "../common/DataComponent";
import * as types from "../../constants/actionTypes";
import * as Tools from "../../helpers/Tools";
import { logUI } from "../../api/andyliticsApi";
import { Link } from "react-router-dom";
import { withTranslation } from 'react-i18next';

export const initialState = {
    fields: {
        userName: "",
        zipCode: "",
        dob: ""
    },
    errors: {},
    showErrors: false
};

/**
* Container component for the Forgot Password page.
*
 */
class ForgotPassword extends DataComponent {

    constructor(props) {
        super(props);

        this.state = Tools.deepCopy(initialState);

        this.forgotPasswordClick = this.forgotPasswordClick.bind(this);
        this.validateInputs = this.validateInputs.bind(this);
        const { clearForgotPassword } = props;
        if (clearForgotPassword) {
            clearForgotPassword();
        }
    }

    componentDidMount() {
        if (super.componentDidMount) { super.componentDidMount(); }
        logUI("MBHWeb.UI.ForgotPassword.ComponentDidMount", new Date(), Tools.getURLPath());
    }

    componentWillUnmount() {
        super.componentWillUnmount();
        const { clearForgotPassword } = this.props;
        this.setState(Tools.deepCopy(initialState));
        clearForgotPassword();
    }

    validateInputs() {
        const { userName, zipCode, dob } = this.state.fields;
        let isFormValid = false;
        if (!Tools.isEmptyString(userName) && Tools.isValidDate(dob) && !Tools.isFutureDate(dob) && Tools.isValidZipCode(zipCode)) {
            isFormValid = true;
        }
        this.setState({ showErrors: !isFormValid });
        return isFormValid;
    }

    onInputChange = (e, field, isValid) => {
        const value = e && e.target && e.target.value ? e.target.value : "";
        if (field === "dob")
            this.onDobChange(e, 'dob');
        else
            this.handleInputChange(e);
        let msg = "";
        if (value && !isValid) {
            switch (field) {
                case "userName":
                    msg = "Please enter your username.";
                    break;
                case "dob":
                    msg = "Please enter a valid date of birth.";
                    break;
                case "zipCode":
                    msg = "Please enter a 5 digit zip code.";
                    break;
                default:
                    msg = "";
            }
        }
        this.setState({ errors: { ...this.state.errors, [field]: msg } }, () => {
            if (this.checkValidity(this.state.errors)) this.setState({ showErrors: false });
        });
    }

    forgotPasswordClick(event) {
        event.preventDefault();
        if (!this.validateInputs()) {
            return false;
        }
        const { userName, dob, zipCode } = this.state.fields;
        const { forgotPassword } = this.props;
        forgotPassword(userName, Tools.dateStringFormat(dob), zipCode);
        logUI("MBHWeb.Settings.ForgotPassword", new Date(), Tools.getURLPath());
    }

    checkValidity = (object) => {
        let isValid = true;
        Object.keys(object).forEach(key => { if (object[key]) isValid = false; });
        return isValid;
    }

    render() {
        var isClientSide = typeof window !== 'undefined';
        const { inProcess, success, failure } = this.props.forgotPasswordAction;
        const { t } = this.props;
        const { errors, showErrors } = this.state;
        window.componentChanged = false;
        return (
            <div className="container-fluid body-logged-out forgot-pw-container">
                <div className={"row " + (showErrors ? " form-submitted " : "")}>
                    <div className="col-12 page-form-sm">
                        <div className="row forgot-pw-logo">
                            <div className="col-12 text-center">
                                <Link to="/login">
                                    <img alt="MyBSWHealth logo" src="/images/mybswlogo.svg" className="img-fluid" />
                                </Link>
                            </div>
                        </div>
                        <div className="row forgot-pw-heading">
                            {!success &&
                                <div className="col-12 text-center">
                                <h1 className="page-heading form-heading">{t("Forgot Your MyBSWHealth Password?")}</h1>
                                <div className="form-sub-heading">{t("Please enter the information below to reset your password.")}</div>
                                </div>
                            }
                        </div>
                        <div className="row align-items-end">
                            {failure &&
                                <div className="col-12 text-center error-msg">
                                    <div>{t(failure.message)}</div>
                                </div>
                            }
                            {success &&
                                <div className="col-12 text-center success-msg">
                                    <div className="status-icon-container"><span className='icon-list-check' /></div>

                                    <div className="col-12 status-banner-msg">
                                    <h1>{t("Your request was successful.")}</h1>
                                    </div>

                                    <div className={`status-subBanner-container`}>
                                        <div className="col-12 status-subBanner-msg">
                                            <h2>{t(success.message)}</h2>
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>
                        {!success && <div className="row forgot-pw-form">
                            {showErrors && <div className="col-12 text-center error-msg">
                                <div>{t("Complete required fields.")}</div>
                            </div>}
                            <div className="col-12 form-group">
                                <GenericInput placeholder="Username"
                                    value={this.state.fields["userName"]} name="userName"
                                    onChange={(e, value, isValid) => { this.onInputChange(e, "userName", isValid) }}
                                    required
                                    inputErrorMsg={errors.userName}
                                    showClearBtn
                                />

                            </div>
                            <div className="col-12 form-group">
                                <DatePicker value={this.state.fields["dob"]} name="dob" placeholder={"Date of Birth"}
                                    type="text" yearsBackward={140} maxDate={new Date()}
                                    onChange={(value, isValid) => { this.onInputChange(value, "dob", isValid) }}
                                    className={errors && errors.dob ? "input-invalid" : null}
                                    showAsInvalid={errors.dob || (showErrors && !this.state.fields["dob"])}
                                    inputErrorMsg={errors && errors.dob}
                                    showClearBtn
                                    required
                                />
                            </div>
                            <div className="col-12 form-group">
                                <ZipCode placeholder="Zip Code"
                                    value={this.state.fields["zipCode"]} name="zipCode"
                                    onChange={(e, isValid) => { this.onInputChange(e, "zipCode", isValid); }}
                                    maxLength={5}
                                    inputErrorMsg={errors.zipCode}
                                    required
                                    showClearBtn
                                    showAsInvalid={errors && errors.zipCode}
                                />
                            </div>
                            {!inProcess ?
                                <div className="col-12 form-group text-center">
                                    <input className="btn btn-primary" type="submit" value="Reset Password" disabled={!isClientSide} onClick={(e) => { this.forgotPasswordClick(e); }} />
                                </div>
                                : <Spinner />
                            }
                        </div>}
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        technicalHelpDeskNumber: state.session.serverData ? state.session.serverData.technicalHelpDeskNumber : "",
        forgotPasswordAction: state.header.forgotPassword ? state.header.forgotPassword : { inProcess : false, success : null, failure : null }
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        forgotPassword: (UserName, DOB, ZipCode) => dispatch({
            type: types.FORGOT_PASSWORD_START, UserName, DOB, ZipCode
        }),
        clearForgotPassword: () => dispatch({ type: types.FORGOT_PASSWORD_CLEAR })
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ForgotPassword));